/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import { redirect, type Params } from 'react-router-dom';

import { getIsPlanInaccessible } from '@fai/friendli-suite/features/products/serverless-endpoints/plan';
import { getProductServerlessEndpointsPlan } from '@fai/friendli-suite/features/routes/loaders/apis/product/serverless-endpoints';
import Paths from '@fai/friendli-suite/features/routes/paths';

export const redirectToModelIfPlanAccessible = async ({ params }: { params: Params<'teamId'> }) => {
  const teamId = params.teamId ?? '';
  const plan = await getProductServerlessEndpointsPlan({ teamId });
  const inaccessibility = getIsPlanInaccessible(plan);

  if (inaccessibility) {
    return null;
  }

  return redirect(Paths.team(teamId).serverlessEndpoints.model.default);
};

export const redirectToLandingIfPlanInaccessible = async ({
  params,
}: {
  params: Params<'teamId'>;
}) => {
  const teamId = params.teamId ?? '';
  const plan = await getProductServerlessEndpointsPlan({ teamId });
  const inaccessibility = getIsPlanInaccessible(plan);

  if (inaccessibility) {
    return redirect(Paths.team(teamId).serverlessEndpoints.landing);
  }

  return null;
};
